import { render, staticRenderFns } from "./RegistrationVerification.vue?vue&type=template&id=a4e0a39a&"
import script from "./RegistrationVerification.vue?vue&type=script&lang=js&"
export * from "./RegistrationVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports